import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import "./SidebarFilter.css";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useResearcher } from "../../context/ResearcherContext";
import { FaBars, FaTimes } from "react-icons/fa";


const SidebarFilter = ({
  onListChange,
  // checkboxList,
  isContacts,
  setFilteredData,
  setIsContacts,
  selectedFromDashboard,
  setSearchData,
  selectedFilters,
  setSelectedFilters,
  selectedListName,
  setSelectedListName,
  setTotalCount,
  currentPage,
  itemsPerPage,
}) => {
  const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

  const navigate = useNavigate();
  const location = useLocation();

  const dropdownRefs = useRef({});
  const [filters, setFilters] = useState({
    listNames: [],
    mycontacts: [],
    companyname: [],
    designation: [],
    industry: [],
    status: [],
    noofemployees: [],
    companylocation: [],
    annualrevenue: [],
    subcategory: [],
    updatedAt: [],
  });

  const [selectedListNames, setSelectedListNames] = useState([]);

  const [shouldCheckMyContacts, setShouldCheckMyContacts] = useState(
    location.state?.checkMyContacts || false
  );
  const [shouldCheckContacts, setShouldCheckContacts] = useState(
    location.state?.checkContacts || false
  );

  useEffect(() => {
    if (
      selectedFromDashboard &&
      !selectedListNames.includes(selectedFromDashboard)
    ) {
      setSelectedListNames([selectedFromDashboard]);
    }
  }, [selectedFromDashboard]);

  useEffect(() => {
    if (location.pathname === "/my-contacts") {
      setIsOpen(true);
      setShouldCheckMyContacts(true);
      setShouldCheckContacts(false);
      setSelectedListName(null);
    } else if (location.pathname === "/contacts") {
      setIsOpen(true);
      setShouldCheckContacts(true);
      setShouldCheckMyContacts(false);
      setSelectedListName(null);
    } else if (location.pathname === "/my-list") {
      setIsMyListOpen(true);
      fetchLists();
      setSelectedListName(null);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.state?.checkMyContacts) {
      setShouldCheckMyContacts(true);
    }
    if (location.state?.checkContacts) {
      setShouldCheckContacts(true);
    }
  }, [location.state]);

  const [searchTerm, setSearchTerm] = useState({ companyname: "" });
  const [role, setRole] = useState("user");
  const [filteredOptions, setFilteredOptions] = useState(filters);
  const [showDropdown, setShowDropdown] = useState({});
  const [isOpen, setIsOpen] = useState({});
  const [isMyListOpen, setIsMyListOpen] = useState(false);
  const [userLists, setUserLists] = useState([]);
  const [searchSelectedItem, setSearchSelectedItem] = useState(null);
  const [selectedSearchOption, setSelectedSearchOption] = useState({});
  const [filteredResults, setFilteredResults] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const { researcherId } = useResearcher();

  useEffect(() => {
    const userRole = localStorage.getItem("role");
    setRole(userRole);
  }, []);

  useEffect(() => {
    if (shouldCheckContacts || shouldCheckMyContacts) {
      setIsOpen((prev) => ({
        ...prev,
        contacts: true,
      }));
    }
  }, [shouldCheckContacts, shouldCheckMyContacts]);

  useEffect(() => {
    if (location.state?.checkMyList) {
      if (location.state?.listName) {
        setSelectedListName(location.state.listName);
      }
      setIsMyListOpen(true);
    }
  }, [location.state]);

  useEffect(() => {
    const hasSelectedFilters = Object.values(selectedFilters).some(
      (arr) => arr.length > 0
    );

    if (hasSelectedFilters) {
      fetchFilterData(selectedFilters);
    }
  }, [selectedFilters]);

  useEffect(() => {
    const hasSelectedFilters = Object.values(selectedFilters).some(
      (arr) => arr.length > 0
    );
    let currentPath = window.location.pathname;

    if (hasSelectedFilters && currentPath === "/my-list") {
      fetchFilterListData(selectedFilters);
    }
  }, [selectedFilters]);

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        let currentPath = window.location.pathname;

        if (currentPath !== "/my-contacts") return;

        const token = localStorage.getItem("token");
        const config = {
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        };

        const [response3, response4] = await Promise.all([
          axios.get(`${baseURL}/api/filters`, config),
          axios.get(`${baseURL}/api/filters/${researcherId}`, config),
        ]);

        const userFilters = response3.data || {};
        const researcherFilters = response4.data || {};

        const combinedFilters = {
          listNames: [
            ...(userFilters.listNames || []),
            ...(researcherFilters.listNames || []),
          ],
          mycontacts: [
            ...(userFilters.mycontacts || []),
            ...(researcherFilters.mycontacts || []),
          ],
          companyname: [
            ...(userFilters.companyname || []),
            ...(researcherFilters.companyname || []),
          ],
          designation: [
            ...(userFilters.designation || []),
            ...(researcherFilters.designation || []),
          ],
          industry: [
            ...(userFilters.industry || []),
            ...(researcherFilters.industry || []),
          ],
          status: [
            ...(userFilters.status || []),
            ...(researcherFilters.status || []),
          ],
          updatedAt: [
            ...(userFilters.updatedAt || []),
            ...(researcherFilters.updatedAt || []),
          ],
          noofemployees: [
            ...(userFilters.noofemployees || []),
            ...(researcherFilters.noofemployees || []),
          ],
          companylocation: [
            ...(userFilters.companylocation || []),
            ...(researcherFilters.companylocation || []),
          ],
          annualrevenue: [
            ...(userFilters.annualrevenue || []),
            ...(researcherFilters.annualrevenue || []),
          ],
          subcategory: [
            ...(userFilters.subcategory || []),
            ...(researcherFilters.subcategory || []),
          ],
        };

        setFilters(combinedFilters);
      } catch (err) {
        console.error("Failed to fetch filter options", err);
      }
    };

    fetchFilterOptions();
  }, [researcherId]);

  useEffect(() => {
    const fetchFilterListData = async () => {
      try {
        let currentPath = window.location.pathname;
        if (currentPath !== "/my-list") return;

        const hasSelectedFilters = Object.values(selectedFilters).some(
          (arr) => arr.length > 0
        );
        if (!hasSelectedFilters && !selectedListName) return;

        const token = localStorage.getItem("token");
        const config = {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        };

        const params = {
          ...selectedFilters,
          listName: selectedListName || null,
        };

        const { data } = await axios.get(`${baseURL}/api/filter-list-data`, {
          params,
          ...config,
        });

        const combinedFilters = {
          listNames: data.listNames || [],
          mycontacts: data.mycontacts || [],
          companyname: data.companyname || [],
          designation: data.designation || [],
          industry: data.industry || [],
          status: data.status || [],
          updatedAt: data.updatedAt || [],
          noofemployees: data.noofemployees || [],
          companylocation: data.companylocation || [],
          annualrevenue: data.annualrevenue || [],
          subcategory: data.subcategory || [],
        };

        setFilters(combinedFilters);
      } catch (err) {
        console.error("Failed to fetch list data", err);
      }
    };

    fetchFilterListData();
  }, [selectedListName]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      Object.keys(dropdownRefs.current).forEach((field) => {
        if (
          dropdownRefs.current[field] &&
          !dropdownRefs.current[field].contains(event.target)
        ) {
          setShowDropdown((prev) => ({ ...prev, [field]: false }));
        }
      });
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchFilterData = async (from, to) => {
    try {
      const params = {
        ...selectedFilters,
        fromdate: from,
        todate: to,
        researcherId,
      };

      const token = localStorage.getItem("token");

      const response = await axios.get(`${baseURL}/api/filter-details`, {
        params,
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = response.data;

      setFilteredResults(data.filteredData);
      setFilteredData(data.filteredData);
      setTotalCount(data.totalCount);
    } catch (error) {
      console.error("Error fetching filter data:", error);
    }
  };

  const fetchFilterListData = async (from, to) => {
    try {
      const params = {
        selectedListName,
        ...selectedFilters,
        fromdate: from,
        todate: to,
        researcherId,
      };

      const token = localStorage.getItem("token");

      const response = await axios.get(`${baseURL}/api/filter-details`, {
        params,
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = response.data;

      setFilteredResults(data.filteredData);
      setFilteredData(data.filteredData);
      setTotalCount(data.totalCount);
    } catch (error) {
      console.error("Error fetching filter data:", error);
    }
  };
  const fetchLists = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire({
        icon: "warning",
        text: "You need to login first",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return;
    }
    try {
      const response = await fetch(`${baseURL}/api/get-lists`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();

      if (data.lists) {
        setUserLists(data.lists || []);
      } else {
        setUserLists([]);
      }
    } catch (error) {
      console.error("Error fetching lists:", error);
      Swal.fire({
        icon: "error",
        text: "Error occurred while fetching lists",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    if (checkboxList?.length > 0) {
      setIsMyListOpen(true);
    }
  }, []);

  const handleSearch = (field, value) => {
    setSearchTerm((prev) => ({ ...prev, [field]: value }));

    if (!value.trim()) {
      setFilteredOptions((prev) => ({
        ...prev,
        [field]: filters[field] || [],
      }));
      setShowDropdown((prev) => ({ ...prev, [field]: false }));
      return;
    }

    let filtered;
    if (field === "listNames") {
      filtered = userLists.filter((list) =>
        list.listName.toLowerCase().includes(value.toLowerCase())
      );
    } else {
      filtered = filters[field]?.filter((option) =>
        option?.toLowerCase().includes(value.toLowerCase())
      );
    }

    setFilteredOptions((prev) => ({ ...prev, [field]: filtered || [] }));
    setShowDropdown((prev) => ({ ...prev, [field]: true }));
  };

  const toggleDropdown = (field) => {
    setIsOpen((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleCheckboxChange = (field, option) => {
    let updated;

    const normalizedOption = field === "updatedAt" ? option : option;

    if (field === "updatedAt") {
      updated = selectedFilters[field]?.includes(normalizedOption)
        ? selectedFilters[field].filter((item) => {
            const normalizedItem = item;
            console.log("item:", normalizedItem);
            console.log("option:", normalizedOption);
            return normalizedItem !== normalizedOption;
          })
        : [...(selectedFilters[field] || []), normalizedOption];
    } else {
      updated = selectedFilters[field]?.includes(option)
        ? selectedFilters[field].filter((item) => item !== option)
        : [...(selectedFilters[field] || []), option];
    }

    const updatedFilters = { ...selectedFilters, [field]: updated };

    setSelectedFilters(updatedFilters);

    if (setSearchData) {
      setSearchData(updatedFilters);
    }
  };

  const toggleMyListDropdown = () => {
    setIsMyListOpen((prev) => !prev);
    if (!isMyListOpen) fetchLists();
  };

  const fieldNamesMap = {
    mycontacts: "Contacts",
    listNames: "My List",
    companyname: "Company Name",
    designation: "Designations",
    industry: "Industries",
    status: "Status",
    updatedAt: "Last Updated",
    noofemployees: "No of Employees",
    companylocation: "Locations",
    annualrevenue: "Revenues",
    subcategory: "Subcategories",
  };

  const baseList = userLists.slice(0, 3);

  const checkboxList = (() => {
    if (
      searchSelectedItem &&
      !baseList.some((item) => item.listName === searchSelectedItem.listName)
    ) {
      return [...baseList.slice(0, 2), searchSelectedItem];
    }
    return baseList;
  })();

  return (
    <>
     <div className="hamburger-sidebar" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
        {isSidebarOpen ? <FaTimes /> : <FaBars />}
      </div>
    <div className={`sidebar-filter ${isSidebarOpen ? "open" : ""}`}>
      {(role === "user" || role === "researcher" || role === "admin") && (
        <div className="company-list">
          <div
            className="company-drop"
            onClick={() => toggleDropdown("contacts")}
          >
            
          </div>

          {(
            <div className="filter-options">
              {(role === "researcher" || role === "admin") && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "left",
                    gap: "5px",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={shouldCheckContacts}
                    onChange={(e) => {
                      setSelectedListName(null);
                      setIsContacts(true);
                      if (e.target.checked) {
                        navigate("/contacts", {
                          state: { shouldCheckContacts: true },
                        });
                      }
                    }}
                  />

                  <p>Contacts</p>
                </div>
              )}
              {role === "user" && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "left",
                    alignItems: "center",
                    marginTop: "0px",
                    gap: "5px",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={shouldCheckMyContacts}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setSelectedListName(null);

                      if (checked) {
                        navigate("/my-contacts", {
                          state: { shouldCheckMyContacts: true },
                        });
                      }
                    }}
                  />

                  <p style={{fontWeight:"600", fontSize:"14px"}}>My Contacts</p>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {role === "user" && (
        <div className="company-list">
          <div className="list-drop" onClick={toggleMyListDropdown}>
            <div className="list">My Lists</div>
            {isMyListOpen ? <FaAngleUp /> : <FaAngleDown />}
          </div>

          {isMyListOpen && (
            <div className="filter-options">
              {showDropdown["listNames"] &&
                filteredOptions["listNames"]?.length > 0 && (
                  <div className="dropdown">
                    {filteredOptions["listNames"].map((item, index) => (
                      <div
                        key={index}
                        className="dropdown-item"
                        onClick={() => {
                          setSelectedListName(item.listName);
                          setSearchSelectedItem(item);
                          setShowDropdown((prev) => ({
                            ...prev,
                            listNames: false,
                          }));
                          // navigate("/my-list", {
                          //   state: { listName: item.listName },
                          // });
                        }}
                      >
                        {item.listName}
                      </div>
                    ))}
                  </div>
                )}

              {Array.isArray(checkboxList) &&
              (searchTerm["listNames"]
                ? filteredOptions["listNames"]
                : checkboxList
              ).length > 0 ? (
                (searchTerm["listNames"]
                  ? filteredOptions["listNames"]
                  : checkboxList
                ).map((item) => (
                  <label
                    key={item._id}
                    style={{ display: "block", marginBottom: "5px" }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedListName === item.listName}
                      onChange={() => {
                        navigate("/my-list", {
                          state: { listName: item.listName },
                        });
                        setSelectedListName(item.listName);
                      }}
                    />
                    {item.listName}
                  </label>
                ))
              ) : (
                <div className="no-lists">Create list.</div>
              )}
              {userLists.length > 3 && (
                <input
                  type="search"
                  className="others"
                  placeholder="Search..."
                  value={searchTerm["listNames"] || ""}
                  onChange={(e) => handleSearch("listNames", e.target.value)}
                  onFocus={() => {
                    setShowDropdown((prev) => ({
                      ...prev,
                      listNames: true,
                    }));
                    setFilteredOptions((prev) => ({
                      ...prev,
                      listNames: userLists,
                    }));
                  }}
                />
              )}
            </div>
          )}
        </div>
      )}

      {Object.keys(filters).map((field) => {
        if (["mycontacts", "listNames", "contacts"].includes(field))
          return null;

        const baseOptions = filters[field].slice(0, 3);
        const selected = selectedFilters[field] || [];
        const extraSelected = selected.filter(
          (opt) => !baseOptions.includes(opt)
        );
        const finalOptions = [...new Set([...baseOptions, ...extraSelected])];

        return (
          <div className="company-list" key={field}>
            <div className="company-drop" onClick={() => toggleDropdown(field)}>
              <div className="company">
                {fieldNamesMap[field] ||
                  field
                    .replace(/([a-z])([A-Z])/g, "$1 $2")
                    .replace(/^./, (str) => str.toUpperCase())}
              </div>
              {isOpen[field] ? <FaAngleUp /> : <FaAngleDown />}
            </div>

            {isOpen[field] && (
              <div
                className="filter-options"
                ref={(el) => (dropdownRefs.current[field] = el)}
              >
                {finalOptions.map((option, index) => (
                  <label key={index} className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={selected.includes(option)}
                      onChange={() => handleCheckboxChange(field, option)}
                    />
                    {option}
                  </label>
                ))}

                {/* Search Input */}
                <input
                  type="search"
                  className="others"
                  placeholder="Search..."
                  value={searchTerm[field] || ""}
                  onChange={(e) => handleSearch(field, e.target.value)}
                  onFocus={() => {
                    setShowDropdown((prev) => ({ ...prev, [field]: true }));
                    setFilteredOptions((prev) => ({
                      ...prev,
                      [field]: filters[field].filter(
                        (opt) => !selected.includes(opt)
                      ),
                    }));
                  }}
                />

                {/* Search Dropdown */}
                {showDropdown[field] && filteredOptions[field]?.length > 0 && (
                  <div className="dropdown">
                    {filteredOptions[field].map((option, index) => (
                      <div
                        key={index}
                        className="dropdown-item"
                        onClick={() => {
                          handleCheckboxChange(field, option);
                          setSelectedSearchOption((prev) => ({
                            ...prev,
                            [field]: option,
                          }));
                          setShowDropdown((prev) => ({
                            ...prev,
                            [field]: false,
                          }));
                          setSearchTerm((prev) => ({
                            ...prev,
                            [field]: "",
                          }));
                        }}
                      >
                        {option}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
    </>
  );
};

export default SidebarFilter;
